import React, { createContext, useContext, useReducer } from 'react';

const AppContext = createContext();

const initialState = {
  sidebarCollapsed: false,
  // On a phone the navigation cannot sit beside the page: the icon rail is 60px and
  // the text panel another 220, which on a 375px screen leaves almost nothing for the
  // work. Below lg it slides over the content instead, and this is whether it is open.
  mobileNavOpen: false,
  activeModule: 'MRP',
  breadcrumb: ['Main Menu', 'MRP', 'MRP Wizard'],
};

function appReducer(state, action) {
  switch (action.type) {
    case 'TOGGLE_SIDEBAR':
      return { ...state, sidebarCollapsed: !state.sidebarCollapsed };
    case 'OPEN_MOBILE_NAV':
      return { ...state, mobileNavOpen: true };
    case 'CLOSE_MOBILE_NAV':
      return { ...state, mobileNavOpen: false };
    case 'SET_ACTIVE_MODULE':
      return { ...state, activeModule: action.payload };
    case 'SET_BREADCRUMB':
      return { ...state, breadcrumb: action.payload };
    default:
      return state;
  }
}

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);
  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be inside AppProvider');
  return ctx;
}
